export enum MapStateDraw {
  drawCircle = 'circle',
  drawArea = 'area',
  drawMarker = 'marker',
}
